type TelemetryPayload = Record<string, unknown>;

const isLocalhost = () => {
  if (typeof window === "undefined") {
    return false;
  }

  return ["localhost", "127.0.0.1"].includes(window.location.hostname);
};

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>;
    gtag?: (command: string, eventName: string, payload?: TelemetryPayload) => void;
  }
}

export const trackTelemetryEvent = (
  eventName: string,
  payload: TelemetryPayload = {}
) => {
  try {
    if (typeof window === "undefined") {
      return;
    }

    if (typeof window.gtag === "function") {
      window.gtag("event", eventName, payload);
      return;
    }

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({
        event: eventName,
        ...payload,
      });
      return;
    }

    if (isLocalhost()) {
      console.info(`[telemetry] ${eventName}`, payload);
    }
  } catch (error) {
    if (isLocalhost()) {
      console.warn("[telemetry] failed to send event", error);
    }
  }
};
